export default __webpack_public_path__ + "static/media/Pack_placed.f791bc74.mp3";